import React from "react";
import styles from "./ReviewCard.module.scss";

interface ReviewCardProps {
  name: string;
  text: string;
  rating: number;
}

const ReviewCard: React.FC<ReviewCardProps> = ({ name, text, rating }) => {
  return (
    <div className={styles.reviewCard}>
      <div className={styles.reviewText}>
        <p>{text}</p>
      </div>
      <div className={styles.reviewFooter}>
        <div className={styles.stars}>
          {Array.from({ length: 5 }, (_, index) =>
            index < rating ? (
              <img
                key={index}
                src="/images/star-full.svg"
                alt="filled star"
                width="25"
                height="25"
                className={styles.starIcon}
              />
            ) : (
              <img
                key={index}
                src="/path/to/star-empty.svg"
                alt="empty star"
                className={styles.starIcon}
              />
            )
          )}
        </div>
        <div className={styles.reviewAuthor}>{name}</div>
      </div>
    </div>
  );
};

export default ReviewCard;
